import { ISiteMode, ICreateSignupLeadRequest, ISignupLead } from '../interfaces/heavyDutyMachinery/ISiteMode';
import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';

const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL;

/**
 * Which face the site is wearing. Anonymous, because it is asked before
 * anybody could be signed in.
 *
 * Fails CLOSED towards the app, not the landing: if the API cannot be
 * reached, showing the real app to whoever is already using it beats
 * replacing it with a "coming soon" page because of a dropped request.
 * The landing is the exception, so it takes a real answer to turn on.
 */
export const getSiteMode = async (): Promise<ISiteMode> => {
  const response = await apiService<ISiteMode>({
    url: API_ENDPOINTS.PUBLIC_SITE_MODE,
    method: HTTP_METHODS.GET,
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return response.data;
  return { landingModeEnabled: false, registrationEnabled: true };
};

export const createSignupLead = async (request: ICreateSignupLeadRequest): Promise<void> => {
  const response = await apiService<void>({
    url: API_ENDPOINTS.PUBLIC_SIGNUP_LEADS,
    method: HTTP_METHODS.POST,
    body: { ...request },
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (!response.success) throw new Error(response.error || 'Failed to submit');
};

export const getSignupLeads = async (): Promise<ISignupLead[]> => {
  const response = await apiService<ISignupLead[]>({
    url: API_ENDPOINTS.ADMIN_SIGNUP_LEADS,
    method: HTTP_METHODS.GET,
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to load the waiting list');
};

export const setSignupLeadContacted = async (id: number, contacted: boolean): Promise<ISignupLead> => {
  const response = await apiService<ISignupLead>({
    url: API_ENDPOINTS.ADMIN_SIGNUP_LEAD_CONTACTED(id, contacted),
    method: HTTP_METHODS.POST,
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to update');
};
